import React from "react";
import "./Services.css";
import { Element } from "react-scroll";
import SendMoney from "../../assests/send_money.png";
import PhoneMockup from "../PhoneMockup/PhoneMockup";

const bills = [
  { icon: "📡", title: "Airtime", desc: "Any network, instantly", offline: true },
  { icon: "📶", title: "Data Bundle", desc: "All networks covered", offline: true },
  { icon: "⚽", title: "Betting", desc: "Fund your wallet fast", offline: false },
  { icon: "📺", title: "TV / Cable", desc: "DSTV, GOtv & more", offline: false },
  { icon: "⚡", title: "Electricity", desc: "Prepaid & postpaid", offline: false },
];

const Services = () => {
  return (
    <Element name="services">
      <section className="svc-section" id="services">
        {/* Section label */}
        <div className="svc-label">Services</div>
        <h2 className="svc-title">
          Everything in <span className="svc-accent">one app.</span>
        </h2>
        <p className="svc-desc">
          From offline bank transfers to bill payments and crypto — all the
          financial tools you need, available 24/7.
        </p>

        {/* ── Bank Transfer card ── */}
        <div className="bt-wrapper">
          <div className="bt-left">
            <div className="bt-tag">Featured</div>
            <h3 className="bt-title">Bank Transfer</h3>
            <p className="bt-body">
              Send money to any Nigerian bank account in seconds. The only
              payment app that works completely offline — no Wi-Fi, no data,
              no problem.
            </p>

            <div className="bt-badges">
              <span className="bt-badge bt-badge-online">
                <span className="badge-dot badge-dot-green"></span>
                Online Mode
              </span>
              <span className="bt-badge bt-badge-offline">
                <span className="badge-dot badge-dot-orange"></span>
                Offline Mode
              </span>
            </div>

            <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
              <button className="bt-btn">Get Started &rarr;</button>
            </a>
          </div>

          {/* Phone mockup showing the send money screen */}
          <div className="bt-right">
            <PhoneMockup
              screenshot={SendMoney}
              alt="Send money screen"
              size="md"
              glow={false}
              className="bt-pm"
            />
          </div>
        </div>

        {/* ── Bills grid ── */}
        <div className="bills-wrapper">
          <div className="bills-title-row">
            <h3 className="bills-title">Bill Payments</h3>
            <p className="bills-sub">Pay any bill in seconds</p>
          </div>
          <div className="bills-grid">
            {bills.map((b, i) => (
              <div className="bill-card" key={i}>
                <span className="bill-icon">{b.icon}</span>
                <h4 className="bill-name">{b.title}</h4>
                <p className="bill-desc">{b.desc}</p>
                <div className="bill-tags">
                  <span className="bill-tag bill-tag-online">Online</span>
                  {b.offline && (
                    <span className="bill-tag bill-tag-offline">Offline</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Services;
